import React from 'react';
import PropTypes from 'prop-types';

const Image = ({additionalClass, imageSrc}) => {
    return(
        <img
            className={additionalClass}
            src={imageSrc} />
    );
};

Image.propTypes = {
    additionalClass: PropTypes.string,
    imageSrc: PropTypes.string
};

export default Image;


// WEBPACK FOOTER //
// ./src/components/base/Image/Image.js